import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

export interface ITraderMapProject {
    archived_at?: string
    created_at: string
    id: string
    priority: number
    status: string
    symbol: string
    symbol_image: string
    updated_at?: string
}

export const getTraderMapProjects = async (active?: boolean): Promise<ApiRes<ITraderMapProject[]>> => {
    return await apiGet(API_URL, `admin/trader/projects`)
}
